import { useEffect, type RefObject } from "react";

type Handler = () => void;

const useClickOutside = (
  refs: RefObject<HTMLElement | null>[],
  handler: Handler,
  mouseEvent: "mousedown" | "mouseup" = "mousedown",
): void => {
  useEffect(() => {
    const listener = (event: MouseEvent) => {
      const target = event.target as Node;

      const clickedInside = refs.some((ref) => {
        const el = ref.current;
        return el && el.contains(target);
      });

      if (clickedInside) return;

      handler();
    };

    document.addEventListener(mouseEvent, listener);

    return () => {
      document.removeEventListener(mouseEvent, listener);
    };
  }, [refs, handler, mouseEvent]);
};

export default useClickOutside;
